import { ROUTES } from '@/constants/routes'

export default function isOwner({ next, router, store }) {
    if (store.isAccountTrial) {
        return router.push({ name: ROUTES.notFound })
    }

    next()
}
